import {
  CURRENT_PRESSURE_VALUE_TYPE_PREFIX,
  CURRENT_PRESSURE_VALUE_TYPE_SUFFIX,
} from './irrigationActivityConstants'

export const isPressureKey = (key: string) =>
  key.startsWith(CURRENT_PRESSURE_VALUE_TYPE_PREFIX) && key.endsWith(CURRENT_PRESSURE_VALUE_TYPE_SUFFIX)
